<div class="my-4 hidden md:block" *ngIf="(isLoading$ | async) === false">
    <h2 class="text-base font-bold leading-5">{{ 'CITY_TICKET_TYPE' | translate }}</h2>
</div>
<div
    class="w-auto max-w-full overflow-y-auto dark:bg-contrast-black md:rounded-lg md:bg-grey-white_smoke md:p-4"
    *ngIf="(isLoading$ | async) === false">
    <div class="mb-4 bg-white shadow-md lg:hidden">
        <h2
            class="orb-app-light-dark:font-medium p-4 text-left text-base font-normal leading-5 text-grey-dark dark:text-contrast-yellow"
            *ngIf="chosenAreasFromPreviousStep?.length === 1; else fromAToB">
            {{ 'TICKET_SUMMARY_V2_ZONE' | translate }}:
            {{ chosenAreasFromPreviousStep?.[0].name | translateObjectField: null : currentLanguage }}
        </h2>
        <ng-template #fromAToB>
            <p class="product-stop flex-align-center relative flex break-all p-4 text-left text-base">
                <ion-icon
                    class="text-old_silver mr-4 h-6 w-6 dark:text-contrast-yellow"
                    title="{{ 'ORIGIN' | translate }}"
                    aria-label="{{ 'ORIGIN' | translate }}"
                    src="{{ assetsPath$ | async }}/img/purchase-flow-v2/product-area/origin.svg"></ion-icon>

                {{ chosenAreasFromPreviousStep?.[0]?.name | translateObjectField: null : currentLanguage }}
            </p>
            <p
                class="product-stop flex-align-center relative flex border-b border-solid border-black border-opacity-10 p-4 pt-0 text-left text-base dark:border-contrast-yellow">
                <ion-icon
                    class="text-old_silver mr-4 h-6 w-6 dark:text-contrast-yellow"
                    title="{{ 'DESTINATION' | translate }}"
                    aria-label="{{ 'DESTINATION' | translate }}"
                    src="{{ assetsPath$ | async }}/img/purchase-flow-v2/product-area/destination.svg"></ion-icon>

                {{ chosenAreasFromPreviousStep?.[1]?.name | translateObjectField: null : currentLanguage }}
            </p>
            <p class="pb-3 pl-4 pr-4 pt-4 text-grey-dark dark:text-contrast-yellow">
                {{ chosenAreasFromPreviousStep?.length }} {{ 'ZONES' | translate }}
            </p>
        </ng-template>
    </div>
    <ng-container *ngIf="noProductsFound">
        <div class="flex flex-col items-center justify-center gap-4 p-12 text-center text-grey-dark">
            <ion-icon class="scale-x-[-1] text-6xl opacity-60 dark:text-contrast-yellow" name="ban-outline"></ion-icon>
            <p class="text-base dark:text-contrast-yellow">{{ 'NO_PRODUCTS_FOUND_DESCRIPTION' | translate }}</p>
        </div>
    </ng-container>

    <!-- NEW AFC WITH BASEFARE GROUPING -->
    <ng-container *ngIf="!noProductsFound && useNewAfcGrouping">
        <ng-container *ngTemplateOutlet="baseFareSubGroupsTemplate; context: { $implicit: parentProductGroups }">
        </ng-container>
    </ng-container>

    <!-- OLD AFC / LEGACY GROUPING -->
    <ng-container *ngIf="!noProductsFound && !useNewAfcGrouping">
        <div class="mb-4 bg-white px-4 shadow-md md:m-0" *ngFor="let productGroup of productsGroups; let index = index">
            <div class="flex items-center justify-between py-1.5">
                <h3
                    class="text-xs font-bold uppercase leading-7 text-grey-dark dark:text-contrast-yellow"
                    [class.normal-case]="env.REMOVE_UPPERCASE"
                    [ngSwitch]="productGroup?.code">
                    <ng-container *ngSwitchCase="ProductCode.PERIOD">
                        {{ 'CATEGORY_PRODUCT_PERIOD' | translate }}
                    </ng-container>

                    <ng-container *ngSwitchCase="ProductCode.MULTI_JOURNEY">
                        <ng-container
                            *ngIf="env.PURCHASE_FLOW?.USE_STATIC_TITLE_MULTI_JOURNEY; else translatedProductName">
                            {{ 'CATEGORY_PRODUCT_BOOKLET_TICKETS' | translate }}
                        </ng-container>
                    </ng-container>

                    <ng-container *ngSwitchCase="ProductCode.JOINT_TICKET">
                        {{ 'JOINT_TICKET_GROUP_TITLE' | translate }}
                    </ng-container>

                    <ng-container *ngSwitchDefault>
                        <ng-container *ngIf="env.PURCHASE_FLOW?.USE_STATIC_TICKET_TITLE; else translatedProductName">
                            {{ 'PURCHASE_FLOW_STATIC_TICKETS_TITLE' | translate }}
                        </ng-container>
                    </ng-container>

                    <ng-template #translatedProductName>
                        {{
                            productGroup?.products[0]?.name
                                | translateObjectField: 'translation' : translate.currentLang
                        }}
                    </ng-template>
                </h3>
                <span
                    class="text-xs font-normal text-grey-dark dark:text-contrast-yellow"
                    *ngIf="product?.price?.amount > 0 && !product?.dynamicLength">
                    {{ 'ADULT_PRICE' | translate }}
                </span>
            </div>
            <ng-container>
                <button
                    class="product solid-border flex w-full items-center justify-between gap-4 border-t border-black border-opacity-10 py-4 text-left focus:outline-none focus:ring-2 focus:ring-blue-500 dark:border-contrast-yellow dark:text-contrast-yellow"
                    *ngFor="let product of productGroup.products"
                    (click)="selectProductGroup(product.id)">
                    <!-- ICONS -->
                    <ng-container [ngSwitch]="productGroup.code">
                        <!-- SINGLE group -->
                        <ng-container *ngSwitchCase="ProductCode.SINGLE">
                            <mat-icon
                                class="gl-light:text-secondary !w-8 text-primary"
                                aria-hidden="true"
                                svgIcon="single"></mat-icon>
                        </ng-container>
                        <ng-container *ngSwitchCase="ProductCode.SINGLE_TICKET_GROUP">
                            <mat-icon
                                class="gl-light:text-secondary !w-8 text-primary"
                                aria-hidden="true"
                                svgIcon="single"></mat-icon>
                        </ng-container>

                        <!-- PERIOD group -->
                        <ng-container *ngSwitchCase="ProductCode.PERIOD">
                            <mat-icon
                                class="gl-light:text-secondary !w-8 text-primary"
                                aria-hidden="true"
                                svgIcon="period"></mat-icon>
                        </ng-container>
                        <ng-container *ngSwitchCase="ProductCode.PERIOD_PASS">
                            <mat-icon
                                class="gl-light:text-secondary !w-8 text-primary"
                                aria-hidden="true"
                                svgIcon="period"></mat-icon>
                        </ng-container>

                        <!-- BOOKLET -->
                        <ng-container *ngSwitchCase="ProductCode.BOOKLET">
                            <mat-icon
                                class="gl-light:text-secondary !w-8 text-primary"
                                aria-hidden="true"
                                svgIcon="booklet"></mat-icon>
                        </ng-container>

                        <!-- MULTI group -->
                        <ng-container *ngSwitchCase="ProductCode.MULTI_JOURNEY">
                            <mat-icon
                                class="gl-light:text-secondary !w-8 text-primary"
                                aria-hidden="true"
                                svgIcon="joint_ticket"></mat-icon>
                        </ng-container>
                        <ng-container *ngSwitchCase="ProductCode.MULTI_TRIP">
                            <mat-icon
                                class="gl-light:text-secondary !w-8 text-primary"
                                aria-hidden="true"
                                svgIcon="joint_ticket"></mat-icon>
                        </ng-container>

                        <!-- JOINT -->
                        <ng-container *ngSwitchCase="ProductCode.JOINT_TICKET">
                            <mat-icon
                                class="gl-light:text-secondary !w-8 text-primary"
                                aria-hidden="true"
                                svgIcon="joint_ticket"></mat-icon>
                        </ng-container>

                        <!-- DEFAULT -->
                        <ng-container *ngSwitchDefault>
                            <mat-icon
                                class="gl-light:text-secondary !w-8 text-primary"
                                aria-hidden="true"
                                svgIcon="single"></mat-icon>
                        </ng-container>
                    </ng-container>
                    <!-- END ICONS -->

                    <div class="product-info flex-1 text-base">
                        <div class="flex-align-center flex justify-between">
                            <p
                                class="product-info__name text-base font-bold leading-5 text-black dark:text-contrast-yellow">
                                {{ product.name | translateObjectField: 'translation' : translate.currentLang }}
                            </p>
                            <p class="font-normal text-grey-dark dark:text-contrast-yellow">
                                <span *ngIf="product?.price?.amount > 0 && !product?.dynamicLength">
                                    {{ product.price.amount | moneyFormat }}
                                    {{ env.CURRENCY || product?.price?.currency || currency }}
                                </span>
                            </p>
                        </div>
                        <p
                            class="pt-2 text-base font-normal leading-5 text-black dark:text-contrast-yellow"
                            *ngIf="product.description && !hideDescription">
                            {{ product.description | translateObjectField: 'translation' : translate.currentLang }}
                        </p>
                        <div
                            class="flex-align-center flex justify-between"
                            *ngIf="
                                (env.PURCHASE_FLOW?.SHOW_TICKET_DURATION_DESCRIPTION &&
                                    productGroup.code === ProductCode.SINGLE) ||
                                productGroup.code === ProductCode.MULTI_JOURNEY
                            ">
                            <p class="font-normal text-grey-dark dark:text-contrast-yellow">
                                <span>
                                    {{
                                        ticketDurationDescriptionService.getProductDurationDescription(
                                            product.products[0].activeTicketDurationInMinutes
                                        )
                                    }}
                                </span>
                            </p>
                        </div>
                    </div>
                    <div class="flex flex-col justify-center p-2 dark:filter-yellow">
                        <ion-icon
                            class="text-black"
                            title="chevron"
                            aria-hidden="true"
                            name="chevron-forward-outline"></ion-icon>
                    </div>
                </button>
            </ng-container>
            <ng-container *ngIf="productGroup.code === 'PERIOD' && env.IS_NEW_AFC">
                <div
                    class="product flex-justify-between flex gap-4 border-t border-black border-opacity-10 pb-4 pt-4 dark:border-contrast-yellow"
                    *ngFor="let period of periodTypesList"
                    (click)="selectProductGroup('productType:period', 'period:' + period.code)">
                    <img
                        class="w-8 dark:filter-yellow"
                        alt="icon-product-24h"
                        aria-hidden="true"
                        src="{{ assetsPath$ | async }}/img/purchase-flow-v2/products/{{
                            productGroup.code.toLowerCase()
                        }}.svg" />
                    <div class="product-info flex-1">
                        <div class="flex-align-center flex justify-between">
                            <p class="product-info__name text-base font-bold leading-5">
                                {{ period.name | translateObjectField: 'translation' : translate.currentLang }}
                            </p>
                            <p class="font-normal text-grey-dark">
                                <span>
                                    {{ getPriceByTimeInterval(period.code) | moneyFormat }}
                                    {{ getCurrencyByTimeInterval(period.code) || appStartupService.getCurrency() }}
                                </span>
                            </p>
                        </div>
                    </div>
                    <div class="flex flex-col justify-center p-2 dark:filter-yellow" aria-hidden="true">
                        <ion-icon
                            class="text-black"
                            title="chevron"
                            aria-hidden="true"
                            name="chevron-forward-outline"></ion-icon>
                    </div>
                </div>
            </ng-container>
        </div>
    </ng-container>
</div>

<!-- NEW AFC TEMPLATE WITH BASEFARE SUB-GROUPS -->
<ng-template #baseFareSubGroupsTemplate let-parentProductGroups>
    <div
        class="mb-4 bg-white px-4 shadow-md md:m-0"
        *ngFor="let parentGroup of parentProductGroups; let parentIndex = index">
        <div class="flex items-center justify-between py-1.5">
            <h3
                class="text-xs font-bold uppercase leading-7 text-grey-dark dark:text-contrast-yellow"
                [class.normal-case]="env.REMOVE_UPPERCASE">
                {{ parentGroup.name }}
            </h3>
            <span
                class="text-xs font-normal text-grey-dark dark:text-contrast-yellow"
                *ngIf="product?.price?.amount > 0 && !product?.dynamicLength">
                {{ 'ADULT_PRICE' | translate }}
            </span>
        </div>

        <ng-container *ngIf="parentGroup.baseFareSubGroups && parentGroup.baseFareSubGroups.length > 0">
            <button
                class="product solid-border flex w-full items-center justify-between gap-4 border-t border-black border-opacity-10 py-4 text-left focus:outline-none focus:ring-2 focus:ring-blue-500 dark:border-contrast-yellow dark:text-contrast-yellow"
                *ngFor="let baseFareSubGroup of parentGroup.baseFareSubGroups"
                (click)="selectBaseFareGroup(baseFareSubGroup.baseFareCode)">
                <ng-container [ngSwitch]="parentGroup.code">
                    <ng-container *ngSwitchCase="'SINGLE_GROUP'">
                        <mat-icon
                            class="var-app-light:text-secondary orb-app-light:text-secondary !h-8 !w-8 flex-shrink-0 text-primary dark:text-contrast-yellow"
                            aria-hidden="true"
                            svgIcon="single"></mat-icon>
                    </ng-container>
                    <ng-container *ngSwitchCase="ProductCode.SINGLE_TICKET_GROUP">
                        <mat-icon
                            class="var-app-light:text-secondary orb-app-light:text-secondary !h-8 !w-8 flex-shrink-0 text-primary dark:text-contrast-yellow"
                            aria-hidden="true"
                            svgIcon="single"></mat-icon>
                    </ng-container>
                    <ng-container *ngSwitchCase="ProductCode.PERIOD">
                        <mat-icon
                            class="var-app-light:text-secondary orb-app-light:text-secondary !h-8 !w-8 flex-shrink-0 text-primary dark:text-contrast-yellow"
                            aria-hidden="true"
                            svgIcon="period"></mat-icon>
                    </ng-container>
                    <ng-container *ngSwitchCase="ProductCode.PERIOD_PASS">
                        <mat-icon
                            class="var-app-light:text-secondary orb-app-light:text-secondary !h-8 !w-8 flex-shrink-0 text-primary dark:text-contrast-yellow"
                            aria-hidden="true"
                            svgIcon="period"></mat-icon>
                    </ng-container>
                    <ng-container *ngSwitchCase="ProductCode.BOOKLET">
                        <mat-icon
                            class="var-app-light:text-secondary orb-app-light:text-secondary !h-8 !w-8 flex-shrink-0 text-primary dark:text-contrast-yellow"
                            aria-hidden="true"
                            svgIcon="booklet"></mat-icon>
                    </ng-container>
                    <ng-container *ngSwitchCase="ProductCode.MULTI_JOURNEY">
                        <mat-icon
                            class="logo-category-multi-trip var-app-light:text-secondary orb-app-light:text-secondary !h-8 !w-8 flex-shrink-0 text-primary dark:text-contrast-yellow"
                            aria-hidden="true"
                            svgIcon="joint_ticket"></mat-icon>
                    </ng-container>
                    <ng-container *ngSwitchCase="ProductCode.MULTI_TRIP">
                        <mat-icon
                            class="logo-category-multi-trip var-app-light:text-secondary orb-app-light:text-secondary !h-8 !w-8 flex-shrink-0 text-primary dark:text-contrast-yellow"
                            aria-hidden="true"
                            svgIcon="joint_ticket"></mat-icon>
                    </ng-container>
                    <ng-container *ngSwitchCase="ProductCode.JOINT_TICKET">
                        <mat-icon
                            class="var-app-light:text-secondary orb-app-light:text-secondary !h-8 !w-8 flex-shrink-0 text-primary dark:text-contrast-yellow"
                            aria-hidden="true"
                            svgIcon="joint_ticket"></mat-icon>
                    </ng-container>
                    <ng-container *ngSwitchDefault>
                        <mat-icon
                            class="var-app-light:text-secondary !h-8 !w-8 flex-shrink-0 text-primary dark:text-contrast-yellow"
                            aria-hidden="true"
                            svgIcon="single"></mat-icon>
                    </ng-container>
                </ng-container>

                <div class="product-info min-w-0 flex-1 text-base">
                    <p
                        class="product-name mb-1 overflow-hidden text-ellipsis whitespace-nowrap font-bold leading-5 text-grey-dark dark:text-contrast-yellow">
                        {{ baseFareSubGroup.baseFareName }}
                    </p>
                </div>

                <div class="product-price flex-shrink-0 text-right">
                    <p class="text-base leading-5 text-grey-dark dark:text-contrast-yellow">
                        <span *ngIf="baseFareSubGroup.maxPrice; else noPrice">
                            {{
                                (baseFareSubGroup.maxPrice.amount || baseFareSubGroup.maxPrice.maxAmount) / 100
                                    | number: '1.2-2'
                            }}
                            {{ env.CURRENCY || baseFareSubGroup.maxPrice.currency || currency }}
                        </span>
                        <ng-template #noPrice>
                            <span class="text-gray-400">N/A</span>
                        </ng-template>
                    </p>
                </div>

                <div class="flex flex-col justify-center p-3">
                    <ion-icon
                        class="md hydrated text-black dark:text-contrast-yellow"
                        name="chevron-forward-outline"
                        aria-hidden="true"
                        title="CHEVRON"
                        role="img"></ion-icon>
                </div>
            </button>
        </ng-container>

        <ng-container *ngIf="!parentGroup.baseFareSubGroups || parentGroup.baseFareSubGroups.length === 0">
            <ng-container *ngIf="parentGroup.isParentGroup">
                <ng-container *ngFor="let subGroup of parentGroup.groups">
                    <ng-container *ngFor="let product of subGroup.products">
                        <button
                            class="product solid-border flex w-full items-center justify-between gap-4 border-t border-black border-opacity-10 py-4 text-left focus:outline-none focus:ring-2 focus:ring-blue-500 dark:border-contrast-yellow"
                            *ngFor="let productItem of product.products"
                            (click)="selectProductGroup(productItem.id)">
                            <mat-icon class="!w-8 text-primary" aria-hidden="true" svgIcon="single"></mat-icon>

                            <div class="product-info flex-1 text-base">
                                <p
                                    class="product-name mb-1 overflow-hidden text-ellipsis whitespace-nowrap font-bold leading-5 text-grey-dark dark:text-contrast-yellow">
                                    {{ productItem.name | translateObjectField: 'translation' : currentLanguage }}
                                </p>
                                <p
                                    class="product-description text-sm leading-4 text-grey-dark dark:text-contrast-yellow"
                                    *ngIf="!hideDescription && productItem.description">
                                    {{
                                        productItem.description | translateObjectField: 'translation' : currentLanguage
                                    }}
                                </p>
                            </div>

                            <div class="product-price text-right">
                                <p class="text-base leading-5 text-grey-dark dark:text-contrast-yellow">
                                    {{ productItem.price.amount | number: '1.2-2' }}
                                    {{ env.CURRENCY || productItem.price.currency || currency }}
                                </p>
                            </div>
                        </button>
                    </ng-container>
                </ng-container>
            </ng-container>

            <ng-container *ngIf="!parentGroup.isParentGroup">
                <ng-container *ngFor="let group of parentGroup.groups">
                    <ng-container *ngFor="let product of group.products">
                        <button
                            class="product solid-border flex w-full items-center justify-between gap-4 border-t border-black border-opacity-10 py-4 text-left focus:outline-none focus:ring-2 focus:ring-blue-500 dark:border-contrast-yellow"
                            *ngFor="let productItem of product.products"
                            (click)="selectProductGroup(productItem.id)">
                            <ng-container [ngSwitch]="group.code">
                                <ng-container *ngSwitchCase="ProductCode.PERIOD">
                                    <mat-icon class="!w-8 text-primary" aria-hidden="true" svgIcon="period"></mat-icon>
                                </ng-container>
                                <ng-container *ngSwitchCase="ProductCode.PERIOD_PASS">
                                    <mat-icon class="!w-8 text-primary" aria-hidden="true" svgIcon="period"></mat-icon>
                                </ng-container>
                                <ng-container *ngSwitchCase="ProductCode.BOOKLET">
                                    <mat-icon class="!w-8 text-primary" aria-hidden="true" svgIcon="booklet"></mat-icon>
                                </ng-container>
                                <ng-container *ngSwitchCase="ProductCode.MULTI_JOURNEY">
                                    <mat-icon
                                        class="!w-8 text-primary"
                                        aria-hidden="true"
                                        svgIcon="joint_ticket"></mat-icon>
                                </ng-container>
                                <ng-container *ngSwitchCase="ProductCode.MULTI_TRIP">
                                    <mat-icon
                                        class="!w-8 text-primary"
                                        aria-hidden="true"
                                        svgIcon="joint_ticket"></mat-icon>
                                </ng-container>
                                <ng-container *ngSwitchCase="ProductCode.JOINT_TICKET">
                                    <mat-icon
                                        class="!w-8 text-primary"
                                        aria-hidden="true"
                                        svgIcon="joint_ticket"></mat-icon>
                                </ng-container>
                                <ng-container *ngSwitchDefault>
                                    <mat-icon class="!w-8 text-primary" aria-hidden="true" svgIcon="single"></mat-icon>
                                </ng-container>
                            </ng-container>

                            <div class="product-info flex-1 text-base">
                                <p
                                    class="product-name mb-1 overflow-hidden text-ellipsis whitespace-nowrap font-bold leading-5 text-grey-dark dark:text-contrast-yellow">
                                    {{ productItem.name | translateObjectField: 'translation' : currentLanguage }}
                                </p>
                                <p
                                    class="product-description text-sm leading-4 text-grey-dark dark:text-contrast-yellow"
                                    *ngIf="!hideDescription && productItem.description">
                                    {{
                                        productItem.description | translateObjectField: 'translation' : currentLanguage
                                    }}
                                </p>
                            </div>

                            <div class="product-price text-right">
                                <p class="text-base leading-5 text-grey-dark dark:text-contrast-yellow">
                                    {{ productItem.price.amount | number: '1.2-2' }} {{ currency }}
                                </p>
                            </div>
                        </button>
                    </ng-container>
                </ng-container>
            </ng-container>
        </ng-container>
    </div>
</ng-template>
